import { render, staticRenderFns } from "./klantselectie.vue?vue&type=template&id=4cb5a158&"
import script from "./klantselectie.vue?vue&type=script&lang=js&"
export * from "./klantselectie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports